export class PlayersService {
    constructor(httpService) {
        this.httpService = httpService;
    }
    async overrideIdentity(playerId) {
        const response = await this.httpService.get(`player/${playerId}/override`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al sobreescribir la identidad del jugador.');
        }
    }
}
